import React from "react";
import "../styles/HR.css";

import {
    LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
    BarChart, Bar, PieChart, Pie, Cell, ResponsiveContainer
} from "recharts";

/* 🔥 DATA */
const trendData = [
    { name: "Jan", vacancies: 50, hired: 30 },
    { name: "Feb", vacancies: 25, hired: 40 },
    { name: "Mar", vacancies: 15, hired: 20 },
    { name: "Apr", vacancies: 60, hired: 60 },
    { name: "May", vacancies: 55, hired: 55 },
    { name: "Jun", vacancies: 20, hired: 30 },
];

const roleData = [
  { role: "DA", male: 30, female: 20, others: 5 },
  { role: "Senior", male: 40, female: 25, others: 5 },
  { role: "Associate", male: 20, female: 15, others: 3 },
  { role: "HRBP", male: 60, female: 30, others: 5 },
  { role: "DE", male: 35, female: 20, others: 4 },
];

const ageData = [
  { age: "18-22", male: 30, female: 20, others: 5 },
  { age: "23-27", male: 40, female: 25, others: 6 },
  { age: "28-32", male: 15, female: 30, others: 8 },
  { age: "33-37", male: 60, female: 20, others: 7 },
  { age: "38-45", male: 40, female: 30, others: 5 },
  { age: "45+", male: 20, female: 25, others: 10 },
];

const pieData = [
    { name: "LinkedIn", value: 20 },
    { name: "Referral", value: 19 },
    { name: "Campus", value: 30 },
    { name: "Lateral", value: 26 },
];

const collegeData = [
    { name: "Public universities", value: 30 },
    { name: "Private universities", value: 40 },
    { name: "Ivy League", value: 15 },
    { name: "Technical schools", value: 60 },
    { name: "Arts colleges", value: 40 },
    { name: "Community colleges", value: 20 },
];

const COLORS = ["#5A67D8", "#7F9CF5", "#B794F4", "#9F7AEA"];

export default function HRDashboard() {
    return (
        <div className="hr-dashboard">

            {/* FILTER */}
            <div className="hr-filters">
                <Filter label="Start date" />
                <Filter label="End date" />
                <Filter label="Department" type="select" />
                <Filter label="Job Role" type="select" />
                <Filter label="Recruiter" type="select" />
                <Filter label="Location" type="select" />
                <Filter label="Type" type="select" />
            </div>

            {/* KPI */}
            <div className="hr-kpi-grid">
                <KPI title="Vacancies" value="752" change="-5%" prev="792" type="down" />
                <KPI title="Applications" value="2.3K" change="+8%" prev="2.1K" type="up" />
                <KPI title="Shortlisted" value="1.3K" change="-7%" prev="1.4K" type="down" />
                <KPI title="Assessment" value="217" change="+8%" prev="199" type="up" />
                <KPI title="Interview" value="138" change="-5%" prev="145" type="down" />
                <KPI title="Offers" value="78" change="+30%" prev="54" type="up" />
                <KPI title="Hired" value="38" change="-13%" prev="43" type="down" />
            </div>

            {/* GRID */}
            <div className="hr-grid">

                {/* PIE */}
                <div className="hr-box">

                    {/* HEADER WITH DROPDOWN */}
                    <div className="box-header">
                        <h4>Hired Candidates By Source</h4>

                        <select className="chart-dropdown">
                            <option>Hired Candidates</option>
                            <option>Applications</option>
                        </select>
                    </div>

                    <ResponsiveContainer width="100%" height={240}>
                        <PieChart>
                            <Pie
                                data={pieData}
                                dataKey="value"
                                innerRadius={60}
                                outerRadius={85}
                                paddingAngle={2}
                                labelLine={false}
                                label={({ name, percent }) =>
                                    `${name} ${(percent * 100).toFixed(0)}%`
                                }
                            >
                                {pieData.map((e, i) => (
                                    <Cell key={i} fill={COLORS[i]} />
                                ))}
                            </Pie>

                            <Tooltip />
                        </PieChart>
                    </ResponsiveContainer>

                </div>

                {/* LINE */}
                <div className="hr-box">

                    <h4>Hiring to Vacancy Trend</h4>

                    {/* LEGEND */}
                    <div className="chart-legend">
                        <span className="legend-item">
                            <span className="dot light"></span> Vacancies
                        </span>
                        <span className="legend-item">
                            <span className="dot dark"></span> Hired
                        </span>
                    </div>

                    <ResponsiveContainer width="100%" height={240}>
                        <LineChart data={trendData}>

                            <CartesianGrid stroke="#e5e7eb" strokeDasharray="3 3" />

                            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                            <YAxis tick={{ fontSize: 12 }} />

                            <Tooltip />

                            {/* Vacancies */}
                            <Line
                                type="monotone"
                                dataKey="vacancies"
                                stroke="#A3BFFA"
                                strokeWidth={2}
                                dot={{ r: 4 }}
                            />

                            {/* Hired */}
                            <Line
                                type="monotone"
                                dataKey="hired"
                                stroke="#4338CA"
                                strokeWidth={3}
                                dot={{ r: 5 }}
                            />

                        </LineChart>
                    </ResponsiveContainer>

                </div>
                {/* STACKED BAR */}
                <div className="hr-box">

  <h4>Hired by Job Roles</h4>

  {/* LEGEND */}
  <div className="chart-legend">
    <span className="legend-item">
      <span className="dot male"></span> Male
    </span>
    <span className="legend-item">
      <span className="dot female"></span> Female
    </span>
    <span className="legend-item">
      <span className="dot others"></span> Others
    </span>
  </div>

  <ResponsiveContainer width="100%" height={240}>
    <BarChart data={roleData} barSize={30}>

      <CartesianGrid stroke="#e5e7eb" strokeDasharray="3 3" />
      <XAxis dataKey="role" tick={{ fontSize: 12 }} />
      <YAxis tick={{ fontSize: 12 }} />
      <Tooltip />

      <Bar dataKey="male" stackId="a" fill="#4338CA" radius={[6,6,0,0]} />
      <Bar dataKey="female" stackId="a" fill="#818CF8" />
      <Bar dataKey="others" stackId="a" fill="#C7D2FE" />

    </BarChart>
  </ResponsiveContainer>

</div>

                {/* LEFT BAR */}
                <div className="hr-box">
                    <div className="box-header">
                        <h4>Hired</h4>
                        <select className="chart-dropdown">
                            <option>Campus</option>
                        </select>
                    </div>

                    <ResponsiveContainer width="100%" height={240}>
                        <BarChart
                            layout="vertical"
                            data={collegeData}
                            margin={{ top: 10, right: 20, left: 60, bottom: 10 }}
                        >
                            <XAxis type="number" hide />
                            <YAxis
                                dataKey="name"
                                type="category"
                                tick={{ fontSize: 12 }}
                            />
                            <Tooltip />

                            <Bar
                                dataKey="value"
                                fill="#4F46E5"
                                radius={[0, 6, 6, 0]}
                                label={{
                                    position: "right",
                                    fill: "#111827",
                                    fontSize: 11,
                                }}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                {/* HEATMAP */}
                <div className="hr-box">
                    <h4>Salary distribution by Experience for hired candidates</h4>

                    <table className="heatmap">
                        <thead>
                            <tr>
                                <th></th>
                                <th>&lt;50K</th>
                                <th>$51K-$100K</th>
                                <th>$101K-$200K</th>
                                <th>$201K-$300K</th>
                                <th>301K+</th>
                            </tr>
                        </thead>

                        <tbody>
                            {[
                                { age: "18-22", data: [4, 11, 5, 12, 3] },
                                { age: "23-27", data: [6, 5, 14, 17, 9] },
                                { age: "28-32", data: [11, 21, 15, 25, 15] },
                                { age: "33-37", data: [6, 12, 23, 5, 23] },
                            ].map((row, i) => (
                                <tr key={i}>
                                    <td className="row-label">{row.age}</td>

                                    {row.data.map((val, idx) => (
                                        <td
                                            key={idx}
                                            style={{
                                                background: `rgba(90,103,216, ${val / 30})`,
                                                color: val > 15 ? "#fff" : "#000",
                                                fontWeight: 500,
                                            }}
                                        >
                                            {val}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* AGE */}
                <div className="hr-box">

  <h4>Hired by Age Bracket</h4>

  {/* LEGEND */}
  <div className="chart-legend">
    <span className="legend-item">
      <span className="dot male"></span> Male
    </span>
    <span className="legend-item">
      <span className="dot female"></span> Female
    </span>
    <span className="legend-item">
      <span className="dot others"></span> Others
    </span>
  </div>

  <ResponsiveContainer width="100%" height={240}>
    <BarChart data={ageData} barSize={18}>

      <CartesianGrid stroke="#e5e7eb" strokeDasharray="3 3" />

      <XAxis dataKey="age" tick={{ fontSize: 12 }} />
      <YAxis tick={{ fontSize: 12 }} />

      <Tooltip />

      {/* GROUPED BARS (no stackId) */}
      <Bar dataKey="male" fill="#4338CA" radius={[4,4,0,0]} />
      <Bar dataKey="female" fill="#818CF8" radius={[4,4,0,0]} />
      <Bar dataKey="others" fill="#C7D2FE" radius={[4,4,0,0]} />

    </BarChart>
  </ResponsiveContainer>

</div>

            </div>
        </div>
    );
}

/* COMPONENTS */
const Filter = ({ label, type }) => (
    <div className="filter-box">
        <label>{label}</label>

        <div className="input-wrapper">
            {type === "select" ? (
                <select>
                    <option>All</option>
                </select>
            ) : (
                <input type="date" />
            )}
        </div>
    </div>
);

const KPI = ({ title, value, change, prev, type }) => (
    <div className="hr-kpi-card">

        <h5>{title}</h5>

        <div className="kpi-value">
            {value}
            <span className={type === "up" ? "arrow up" : "arrow down"}>
                {type === "up" ? "▲" : "▼"}
            </span>
        </div>

        <div className="kpi-footer">
            <span className={type === "up" ? "kpi-up" : "kpi-down"}>
                {change}
            </span>
            <span className="prev">vs prev = {prev}</span>
        </div>

    </div>
);